import React, { useState, useEffect, useCallback } from 'react';
import api from '../api/axiosConfig';
import { showErrorAlert } from '../utils/alert';
import './ServicePage.css';

const ServiceResponsesPage = () => {
  const [responses, setResponses] = useState([]);

  const fetchData = useCallback(async () => {
    try {
      const { data } = await api.get('/api/service-response');
      setResponses(data);
    } catch (error) {
      console.error("Gagal mengambil data respons:", error);
      showErrorAlert("Gagal memuat data respons.");
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const getStatusBadge = (status) => {
    switch (status) {
      case 'setuju':
        return <span className="role-badge role-user">Disetujui</span>;
      case 'jadwal_ulang':
        return <span className="role-badge role-operator">Minta Jadwal Ulang</span>;
      default:
        return <span className="role-badge" style={{backgroundColor: '#eee', color: '#555'}}>Belum Merespons</span>;
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <p>Feedback / Respons Servis</p>
        <h1>Respons Jadwal Servis dari Pengguna</h1>
      </div>
      <div className="content-card">
        <table className="data-table">
          <thead>
            <tr>
              <th>Tanggal Respons</th>
              <th>Pengguna</th>
              <th>Kendaraan</th>
              <th>Jadwal Awal</th>
              <th>Status</th>
              <th>Catatan</th>
            </tr>
          </thead>
          <tbody>
            {responses.map((item) => (
              <tr key={item._id}>
                <td>{item.respondedAt ? new Date(item.respondedAt).toLocaleString('id-ID') : '-'}</td>
                <td>{item.penggunaKendaraan?.nama || 'N/A'}</td>
                <td>{item.jadwalServis?.kendaraan?.nomorKendaraan || 'N/A'}</td>
                <td>{item.jadwalServis?.tanggal ? new Date(item.jadwalServis.tanggal).toLocaleDateString('id-ID') : 'N/A'}</td>
                <td>{getStatusBadge(item.response)}</td>
                <td>{item.catatan || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServiceResponsesPage;